import {
  getSuppliersLogic,
  getSuppliersByUserLogic,
  updateSupplierLogic,
  deleteSupplierLogic,
  getSubcategoriesBySuppliersAndUserLogic,
} from "./Suppliers.logic";
import {
  saveListSuppliers,
  saveListSuppliersBySubcategory,
  saveListSuppliersByUser,
  deleteSelectedSupplierst,
  saveCountSuppliers,
} from "../Infrastructure/Suppliers.store";

export async function getSuppliers() {
  const { count, resources: suppliers } = await getSuppliersLogic();
  saveListSuppliers(suppliers);
  saveCountSuppliers(count);
}
export async function getSuppliersByUser(id) {
  const suppliers = await getSuppliersByUserLogic(id);
  saveListSuppliersByUser(suppliers);
}
export async function updateSupplier(id, params) {
  await updateSupplierLogic(id, params);
}

export async function deleteSupplier(id) {
  await deleteSupplierLogic(id);
  deleteSelectedSupplierst(id);
}

export async function getSubcategoriesBySuppliersAndUser(id) {
  const suppliers = await getSubcategoriesBySuppliersAndUserLogic(id);
  saveListSuppliersBySubcategory(id, suppliers);
}
